import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Button,
  Checkbox
} from '@chakra-ui/react';
import { CreateTrainGroupsApi } from '../../../../apis/CreateMaintenance.api';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { TrainGroupsType } from '../Table/MaintenanceTrainGroupsTable';
import { AxiosError } from 'axios';

interface props {
  isOpen: boolean;
  onClose: () => void;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<TrainGroupsType[] | null | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetTrainGroupInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 6, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 6, BanInputType: BanInputType.None, Value: addData };
};

const TrainGroupsCreateWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, setMaintenanceDatas, CreateOrUpdateStateSwitch } =
    props;
  const [trainGroup, setTrainGroup] = useState<string | undefined>('');
  const [lowFloorCheck, setLowFloorCheck] = useState(false);

  const CreateApi = async () => {
    const response = await CreateTrainGroupsApi({
      name: trainGroup,
      low_floor_flg: lowFloorCheck
    });

    if (
      response.message !== null &&
      (response.message as AxiosError).status?.toString() === '409'
    ) {
      alert('既に登録されている形式です。');
      return;
    } else if (response.success === false) {
      alert('登録に失敗しました。');
      return;
    }
    setMaintenanceDatas(response.data as TrainGroupsType[]);
    CreateOrUpdateStateSwitch();
    onClose();
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='260px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            車両形式作成
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>形式</Text>
              <CustomStringInput
                CheckInfo={GetTrainGroupInputCheckData('')}
                inputValue={trainGroup}
                setValue={setTrainGroup}
                PhohibitionCharaCheck={false}
              />
              <Text mt={4}>低床車両</Text>
              <Checkbox
                mt={4}
                onChange={(e) => setLowFloorCheck(e.target.checked)}
              ></Checkbox>
            </Box>
            <Button
              mt={10}
              onClick={() => {
                CreateApi();
              }}
            >
              作成
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(TrainGroupsCreateWindow);
